import { createFileRoute } from '@tanstack/react-router'
import { StockDetailPage } from '@/features/warehouse/stock-detail-page'

export const Route = createFileRoute('/_authenticated/warehouse/$stockId')({
  staticData: { title: 'Warehouse stock' },
  component: StockDetailRoute,
})

function StockDetailRoute() {
  const { stockId } = Route.useParams()
  return <StockDetailPage stockId={stockId} />
}
